/**
 * Story card controller
 * @author Umer Hassan, Christine Movius
 */

function getStoryCardButtons() {
  return [
    {
      label: 'META',
      icon: 'fa-info-circle',
      tab: 'metadata'
    },
    {
      label: 'TASKS',
      icon: 'fa-inbox',
      tab: 'tasks'
    },
    {
      label: 'PITCHES',
      icon: 'fa-flag',
      tab: 'pitches'
    },
    {
      label: 'PREVIEW',
      icon: 'fa-align-left',
      tab: 'preview'
    }
  ];
}

function StoryCardController(
  $scope,
  storyDrawerService,
  urlConversionService,
  Story,
  $timeout,
  moment
) {
  $scope.delay = false;
  $scope.showPlatformPitches = $scope.delay;
  $scope.detailedView = $scope.$parent.detailedView;
  $scope.liveStory = $scope.story && $scope.story.url ? $scope.story.url : null;

  function drawerCallback(story) {
    angular.extend($scope.story, story);
  }

  $scope.preview = (tab) => {
    storyDrawerService.open($scope.story, tab, {
      ok: drawerCallback,
      cancel(story) {
        drawerCallback(story);
      }
    });
  };

  /**
   * 
   * @param {string} prop 'images' | 'galleries' | 'videos'
   * @returns {Object}
   * [displayData: bool] if true, the property has al leat one item  
   * [counter: string] number of images, galleries, or videos including 
   * the lead_art asterisk
   */
  $scope.mediaCount = (prop) => {
    const mediaData = {};
    let propLenght = 0;
    if ($scope.story.media && $scope.story.media[prop]) {
      propLenght = $scope.story.media[prop].length;
    }

    mediaData.displayData = propLenght > 0;
    mediaData.counter = propLenght.toString();

    // Continue with the lead_art logic only for "articles"
    if ($scope.story.contentType !== 'article') return mediaData;

    if (
      prop === 'galleries' &&
      $scope.story.leadArtType === 'gallery' &&
      $scope.story.leadArt
    ) {
      mediaData.counter = `${propLenght + 1}*`;
    }
    if (
      prop === 'videos' &&
      $scope.story.leadArtType === 'video' &&
      $scope.story.leadArt
    ) {
      mediaData.counter = `${propLenght + 1}*`;
    }

    if (prop === 'images') {
      if (
        ($scope.story.leadArt && $scope.story.leadArtType === 'image') ||
        (!$scope.story.leadArt && $scope.story.promoImage)
      ) {
        mediaData.counter = `${propLenght + 1}*`;
      }
    }
    return mediaData;
  };

  /**
   * 
   * @param {string} prop 'images' | 'galleries' | 'videos'
   * @returns if there is at least 1 image, gallery or video,
   *  or if the story has lead_art
   */
  $scope.displayMedia = (prop) => {
    const { displayData, counter } = $scope.mediaCount(prop);
    if (displayData) return true;
    return counter !== '0';
  };

  /**
   * 
   * @param {string} prop 'images' | 'galleries' | 'videos'
   * @returns if the property has lead art
   */
  $scope.displayLeadArtMessage = (prop) => ($scope.mediaCount(prop)).counter.includes('*');

  if ($scope.useCase === 'preview') {
    $scope.actions = [getStoryCardButtons().pop()];
  } else {
    $scope.actions = getStoryCardButtons();
  }

  $scope.toggleShowDetails = (display) => {
    if (display === 'publications') {
      Story.get($scope.story.id).then((data) => {
        $scope.storyDetailed = data;
      });
      $scope.starting = moment().unix();
    }

    if ($scope.display && $scope.display !== display) {
      // switch out the content only
      $scope.display = display;
      return;
    }

    // toggle it to initialize card expand
    $scope.showDetails = !$scope.showDetails;
    $scope.display = display;

    if ($scope.showDetails) {
      // Slowly reveal the contents of the details div
      $scope.delayPromise = $timeout(() => {
        $scope.delay = !$scope.delay;
      }, 500);
    } else {
      // Don't add the delay on card collapse
      $scope.delay = !$scope.delay;
    }
  };

  $scope.$watch('story.url', () => {
    urlConversionService.expandURL($scope.story)
      .then((url) => {
        $scope.liveStory = url;
      });
  });
}

const controllerArray = [
  '$scope',
  'storyDrawerService',
  'urlConversionService',
  'Story',
  '$timeout',
  'moment',
  'featureFlag',
  StoryCardController
];

export default function (ngModule) {
  ngModule.controller('StoryCardController', controllerArray);
}
